import React, { useContext, useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams, GridSortModel } from '@mui/x-data-grid';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, IconButton, Switch, Typography } from '@mui/material';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import { toCurrency, toFormatedNumber } from '../utils/helpers';
import useApiRequest from '../services/apiRequest';
import { Close, LocalAtm } from '@mui/icons-material';
import Detail from './Detail';
import InfoIcon from '@mui/icons-material/Info';
import InfoDialog from './InfoDialog';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import DownloadMenu from './DownloadMenu';
import navbar_background from '../assets/navbar_background.svg';
import InfoOverpriceDialog from './InfoOverpriceDialog';



function ResultsTableOverprice() {
    const { queryStringConverter } = useApiRequest();

    const { userPermissions } = useContext(GlobalStateContext);
    const [pageSize, setPageSize] = useState<number>(100);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [sortField, setSortField] = useState('_score');
    const [sortOrder, setSortOrder] = useState('desc');
    const { descriptionOverprice, filtersOverprice, searchType: search_type } = useContext(GlobalStateContext);
    const { overpriceChartFilter, setOverpriceChartFilter } = useContext(GlobalStateContext);
    const { overpriceChartFilterAux, setOverpriceChartFilterAux } = useContext(GlobalStateContext);
    const { currentUser, setCurrentUser } = React.useContext(GlobalStateContext);
    const { data, error, loading } = useFetch(
        `${endpoints.ITEMS_OVERPRICE + `/${currentUser?.profile.username}`}${queryStringConverter({ page: currentPage, size: pageSize, search_type })}`,
        JSON.stringify({
            description: descriptionOverprice === "" ? null : descriptionOverprice,
            ...filtersOverprice
        }),
        "POST"
    );
    const [showModalDetail, setShowModalDetail] = useState<any>(null)
    const [showExportModal, setShowExportModal] = useState<boolean>(false)
    const [openInfo, setOpenInfo] = useState(false);
    const [info, setInfo] = useState({});
    const [openMore, setOpenMore] = useState(false);



    // Estados para controlar a visibilidade das colunas
    const [hideDescricaoCP, setHideDescricaoCP] = useState(false); // 'Descrição CP'
    const [hideDescricaoRF, setHideDescricaoRF] = useState(false); // 'Descrição RF'
    const [hideFonteCP, setHideFonteCP] = useState(false);         // 'Fonte CP'
    const [hideFonteRF, setHideFonteRF] = useState(false);         // 'Fonte RF'
    const [hideSrvPrd, setHideSrvPrd] = useState(false);           // 'Srv / Prd'
    const [hideQuantidade, setHideQuantidade] = useState(false);   // 'Quantidade'
    const [hidePeriodo, setHidePeriodo] = useState(false);         // 'Período'
    const [hidePrecoCP, setHidePrecoCP] = useState(false);         // 'Preço CP (R$)'
    const [hidePrecoRF, setHidePrecoRF] = useState(false);         // 'Preço RF (R$)'
    const [hideDiffPreco, setHideDiffPreco] = useState(false);     // 'Diferença (R$)'
    const [hideDiffPrecoPercent, setHideDiffPrecoPercent] = useState(false); // 'Percentual de Diferença (%)'
    const [hideInfo, setHideInfo] = useState(false);               // 'Info'

    // Estados para colunas extras inicialmente ocultas
    const [hideLicitacao, setHideLicitacao] = useState(true);      // 'Documento'
    const [hideMunicipio, setHideMunicipio] = useState(true);      // 'Município'
    const [hideOrgao, setHideOrgao] = useState(true);              // 'Órgão'
    const [hideModalidade, setHideModalidade] = useState(true);    // 'Modalidade'
    const [hideTipoLicitacao, setHideTipoLicitacao] = useState(true); // 'Tipo de Licitação'
    const [hideNumProcesso, setHideNumProcesso] = useState(true);  // 'Número do Processo'
    const [hideNumModalidade, setHideNumModalidade] = useState(true); // 'Número da Modalidade'
    const [hideDscDocument, setHideDscDocument] = useState(true);  // 'Descrição do Documento'
    const [hideNomeVencedor, setHideNomeVencedor] = useState(true); // 'Fornecedor'



    const renderCellInfo = (params: GridRenderCellParams) => {
        return (
            <IconButton color="primary" aria-label="add to shopping cart" onClick={() => {
                setOpenInfo(true)
                setInfo(params.row)
            }}>
                <InfoIcon />
            </IconButton>
        )
    }

    const renderCellMore = (params: GridRenderCellParams) => {
        return (
            <IconButton color='warning' aria-label="add to shopping cart" onClick={() => { setOpenMore(true) }}>
                <AddCircleIcon />
            </IconButton>
        )
    }

    const columns: GridColDef[] = [
        { field: 'cp_original', headerName: 'Descrição CP', flex: 1, minWidth: 250, hide: hideDescricaoCP, sortable: false },
        { field: 'rf_original_dsc', headerName: 'Descrição RF', flex: 1, minWidth: 250, hide: hideDescricaoRF, sortable: false },
        { field: 'cp_fonte', headerName: 'Fonte CP', flex: 1, minWidth: 150, hide: hideFonteCP, sortable: false },
        { field: 'rf_fonte', headerName: 'Fonte RF', flex: 1, minWidth: 150, hide: hideFonteRF, sortable: false },
        { field: 'flag_produto_servico', headerName: 'Srv / Prd', minWidth: 100, hide: hideSrvPrd, sortable: false },
        { field: 'qtde_item', headerName: 'Quantidade', minWidth: 120, align: 'left', headerAlign: 'left', hide: hideQuantidade, sortable: false },
        { field: 'periodo', headerName: 'Período', minWidth: 110, align: 'left', headerAlign: 'left', hide: hidePeriodo, sortable: false, },
        { field: 'cp_preco', headerName: 'Preço CP (R$)', minWidth: 150, align: 'left', headerAlign: 'left', hide: hidePrecoCP, sortable: false, valueFormatter: ({ value }) => toCurrency(value) },
        { field: 'rf_preco', headerName: 'Preço RF (R$)', minWidth: 150, align: 'left', headerAlign: 'left', hide: hidePrecoRF, sortable: false, valueFormatter: ({ value }) => toCurrency(value) },
        { field: 'diff_preco', headerName: 'Diferença (R$)', minWidth: 150, align: 'left', headerAlign: 'left', hide: hideDiffPreco, sortable: false, valueFormatter: ({ value }) => toCurrency(value) },
        { field: 'diff_preco_percent', headerName: 'Percentual de Diferença (%)', minWidth: 150, align: 'left', headerAlign: 'left', sortable: false, hide: hideDiffPrecoPercent, valueFormatter: ({ value }) => `${value.toFixed(2)}%` },

        // Colunas extras inicialmente ocultas
        { field: 'id_licitacao', headerName: 'Documento', flex: 1, minWidth: 120, hide: hideLicitacao, sortable: false },
        { field: 'municipio', headerName: 'Município', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideMunicipio, sortable: false },
        { field: 'orgao', headerName: 'Órgão', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideOrgao, sortable: false },
        { field: 'modalidade', headerName: 'Modalidade', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideModalidade, sortable: false },
        { field: 'tipo_licitacao', headerName: 'Tipo de Licitação', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideTipoLicitacao, sortable: false },
        { field: 'num_processo', headerName: 'Número do Processo', minWidth: 200, align: 'left', headerAlign: 'left', hide: hideNumProcesso, sortable: false },
        { field: 'num_modalidade', headerName: 'Número da Modalidade', minWidth: 200, align: 'left', headerAlign: 'left', hide: hideNumModalidade, sortable: false },
        { field: 'dsc_document', headerName: 'Descrição do Documento', minWidth: 200, align: 'left', headerAlign: 'left', hide: hideDscDocument, sortable: false },
        { field: 'nome_vencedor', headerName: 'Fornecedor', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideNomeVencedor, sortable: false },
        { field: 'info', headerName: 'Info', width: 80, align: 'left', headerAlign: 'left', renderCell: renderCellInfo, sortable: false, hide: hideInfo },

    ];


    // Mapeamento dos dados do JSON para as colunas definidas
    const formatedData = () => {
        // Retorna um array vazio se 'data' for undefined
        if (!data || !data.data) {
            return [];
        }

        return data.data.map((d: any) => ({
            ...d,
            cp_preco: toCurrency(d.cp_preco),
            rf_preco: toCurrency(d.rf_preco),
            diff_preco: toCurrency(d.diff_preco),
            diff_preco_percent: parseFloat(d.diff_preco_percent),
            qtde_item: toFormatedNumber(d.qtde_item),
            periodo: d.periodo ? d.periodo.slice(4, 6) + "/" + d.periodo.slice(0, 4) : " ",
        }));
    };


    const printClick = async () => {
        setShowExportModal(true);
    };


    const onCloseDetail = () => {
        setShowModalDetail(false);
        setOverpriceChartFilter(overpriceChartFilterAux);
    }

    const handleCloseMore = () => {
        setOpenMore(false);
    }

    // Função para mostrar todas as colunas
    const showAllColumns = () => {
        setHideDescricaoCP(false);
        setHideDescricaoRF(false);
        setHideFonteCP(false);
        setHideFonteRF(false);
        setHideSrvPrd(false);
        setHideQuantidade(false);
        setHidePeriodo(false);
        setHidePrecoCP(false);
        setHidePrecoRF(false);
        setHideDiffPreco(false);
        setHideDiffPrecoPercent(false);

        // Colunas extras inicialmente ocultas
        setHideLicitacao(false);
        setHideMunicipio(false);
        setHideOrgao(false);
        setHideModalidade(false);
        setHideTipoLicitacao(false);
        setHideNumProcesso(false);
        setHideNumModalidade(false);
        setHideDscDocument(false);
        setHideNomeVencedor(false);
    };

    // Função para ocultar todas as colunas
    const hideAllColumns = () => {
        setHideDescricaoCP(true);
        setHideDescricaoRF(true);
        setHideFonteCP(true);
        setHideFonteRF(true);
        setHideSrvPrd(true);
        setHideQuantidade(true);
        setHidePeriodo(true);
        setHidePrecoCP(true);
        setHidePrecoRF(true);
        setHideDiffPreco(true);
        setHideDiffPrecoPercent(true);

        // Colunas extras inicialmente ocultas
        setHideLicitacao(true);
        setHideMunicipio(true);
        setHideOrgao(true);
        setHideModalidade(true);
        setHideTipoLicitacao(true);
        setHideNumProcesso(true);
        setHideNumModalidade(true);
        setHideDscDocument(true);
        setHideNomeVencedor(true);
    };



    return (
        <>
            <Dialog open={openMore} onClose={handleCloseMore}>
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Typography variant='h4'>Gerenciar colunas da tabela</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => { handleCloseMore() }}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
                        {/* Primeira coluna com campos relacionados a Documento */}
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5" color="initial" textAlign={'center'} sx={{ mb: 1 }}>Documento</Typography>
                            <FormControlLabel
                                control={
                                    <Switch checked={!hidePeriodo} onChange={() => setHidePeriodo(!hidePeriodo)} name="hidePeriodo" />
                                }
                                label="Período"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideLicitacao} onChange={() => setHideLicitacao(!hideLicitacao)} name="hideLicitacao" />
                                }
                                label="Documento"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideMunicipio} onChange={() => setHideMunicipio(!hideMunicipio)} name="hideMunicipio" />
                                }
                                label="Município"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideOrgao} onChange={() => setHideOrgao(!hideOrgao)} name="hideOrgao" />
                                }
                                label="Órgão"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideModalidade} onChange={() => setHideModalidade(!hideModalidade)} name="hideModalidade" />
                                }
                                label="Modalidade"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideTipoLicitacao} onChange={() => setHideTipoLicitacao(!hideTipoLicitacao)} name="hideTipoLicitacao" />
                                }
                                label="Tipo de Licitação"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideNumProcesso} onChange={() => setHideNumProcesso(!hideNumProcesso)} name="hideNumProcesso" />
                                }
                                label="Número do Processo"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideNumModalidade} onChange={() => setHideNumModalidade(!hideNumModalidade)} name="hideNumModalidade" />
                                }
                                label="Número da Modalidade"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDscDocument} onChange={() => setHideDscDocument(!hideDscDocument)} name="hideDscDocument" />
                                }
                                label="Descrição do Documento"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideNomeVencedor} onChange={() => setHideNomeVencedor(!hideNomeVencedor)} name="hideNomeVencedor" />
                                }
                                label="Fornecedor"
                            />
                        </Box>

                        <Divider orientation="vertical" flexItem />

                        {/* Segunda coluna com campos relacionados a Item */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
                            <Typography variant="h5" color="initial" textAlign={'center'} sx={{ mb: 1 }}>Item</Typography>
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDescricaoCP} onChange={() => setHideDescricaoCP(!hideDescricaoCP)} name="hideDescricaoCP" />
                                }
                                label="Descrição CP"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDescricaoRF} onChange={() => setHideDescricaoRF(!hideDescricaoRF)} name="hideDescricaoRF" />
                                }
                                label="Descrição RF"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideFonteCP} onChange={() => setHideFonteCP(!hideFonteCP)} name="hideFonteCP" />
                                }
                                label="Fonte CP"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideFonteRF} onChange={() => setHideFonteRF(!hideFonteRF)} name="hideFonteRF" />
                                }
                                label="Fonte RF"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideSrvPrd} onChange={() => setHideSrvPrd(!hideSrvPrd)} name="hideSrvPrd" />
                                }
                                label="Srv / Prd"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideQuantidade} onChange={() => setHideQuantidade(!hideQuantidade)} name="hideQuantidade" />
                                }
                                label="Quantidade"
                            />
                        </Box>

                        <Divider orientation="vertical" flexItem />

                        {/* Terceira coluna com campos relacionados a Preços e Diferenças */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
                            <Typography variant="h5" color="initial" textAlign={'center'} sx={{ mb: 1 }}>Preços e Diferenças</Typography>
                            <FormControlLabel
                                control={
                                    <Switch checked={!hidePrecoCP} onChange={() => setHidePrecoCP(!hidePrecoCP)} name="hidePrecoCP" />
                                }
                                label="Preço CP (R$)"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hidePrecoRF} onChange={() => setHidePrecoRF(!hidePrecoRF)} name="hidePrecoRF" />
                                }
                                label="Preço RF (R$)"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDiffPreco} onChange={() => setHideDiffPreco(!hideDiffPreco)} name="hideDiffPreco" />
                                }
                                label="Diferença (R$)"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDiffPrecoPercent} onChange={() => setHideDiffPrecoPercent(!hideDiffPrecoPercent)} name="hideDiffPrecoPercent" />
                                }
                                label="Percentual de Diferença (%)"
                            />
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                        <Button variant="text" color="primary" onClick={hideAllColumns}>
                            Ocultar Todas
                        </Button>
                        <Button variant="text" color="primary" onClick={showAllColumns}>
                            Mostrar Todas
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            <div className=''>
                <InfoOverpriceDialog open={openInfo} onClose={() => { setOpenInfo(false) }} info={info} />
                {showModalDetail ? <Detail open onClose={onCloseDetail} /> : null}
                <div className='bg-white'>



                    <div className='h-result px-2'>

                        <DataGrid
                            hideFooterSelectedRowCount
                            paginationMode='server'
                            pageSize={pageSize}
                            rows={formatedData() || []}
                            rowCount={data?.total || 0}
                            page={currentPage}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            onPageChange={(newPage) => setCurrentPage(newPage)}
                            columns={columns}
                            getRowId={(e: any) => e.id_item}
                            sx={{ fontSize: 13 }}
                            loading={loading}
                        />

                        <Box sx={{ display: 'flex', mt: '-3%', ml: 1 }}>

                            <Button sx={{ ml: 1 }} variant="contained" onClick={() => setOpenMore(true)} startIcon={<BackupTableIcon />}>Gerenciar Tabela</Button>

                        </Box>
                    </div>


                </div>
            </div>
        </>

    );
}

export default ResultsTableOverprice;
